import { render, staticRenderFns } from "./DocumentPrevisulizer.vue?vue&type=template&id=4068de91&"
import script from "./DocumentPrevisulizer.vue?vue&type=script&lang=js&"
export * from "./DocumentPrevisulizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports